import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/_services/auth.service';
import { CompanyService } from 'src/app/_services/company.service';
import { Company } from 'src/models/company.model';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare var $;

@Component({
  selector: 'popup-sensitive-infomation-types',
  templateUrl: './popup-sensitive-infomation-types.component.html',
  styles: [],
})
export class PopupSensitiveInformationType implements OnInit {
  sensitiveInformationTypes: any[] = [];

  protected ngbModalRef: NgbModalRef;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public bsModalRef: BsModalRef,
    public toastrService: ToastrService,
    public translateService: TranslateService
  ) {}

  ngOnInit() {}

  cancel() {
    this.activeModal.dismiss();
  }
}
